import { Amplify } from "aws-amplify";
import awsconfig from "../../aws-exports.js";

import {
  Authenticator,
  useTheme,
  View,
  Image,
  useAuthenticator,
  Text,
  Button,
  TextField,
  RadioGroupField,
  Radio,
  Divider,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

//ログイン画面の日本語化
import { I18n } from "aws-amplify";
import { translations } from "@aws-amplify/ui-react";

import { RiyoukiyakuCheckbox } from "./RiyoukiyakuCheckbox.tsx";
import AccountInfoModal from "./AccountInfoModal";
import SubscriptionModal from "./SubscriptionModal"; // サブスクリプション案内のモーダル
import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import BsButton from "react-bootstrap/Button";
import { useWindowSize } from "../../hooks/useWindowSize.js";
import { useAuthStatus } from "../../context/AuthContext.jsx";
import { Spinner } from "react-bootstrap";
import { VOCABULARIES_JP } from "../../constants/Constant.js";
import TermsOfUseUpdateModal from "./TermsOfUseUpdateModal";
import { isLatestTermsConsented } from "../../utils/Util.js";

I18n.putVocabularies(translations);
I18n.setLanguage("ja");
//ログイン画面の日本語の変更
I18n.putVocabulariesForLanguage("ja", VOCABULARIES_JP);

Amplify.configure(awsconfig);

const services = {
  async validateCustomSignUp(formData) {
    if (!formData.acknowledgement) {
      return {
        acknowledgement: "利用規約に同意し、チェックを入れてください",
      };
    }
  },
  async testfunc(formData) {
    console.log(formData);
  },
};

const LoginButton = () => {
  const [showAuthenticator, setShowAuthenticator] = useState(false);
  const [showAccountInfo, setShowAccountInfo] = useState(false);
  const [showSubscription, setShowSubscription] = useState(false); // サブスクリプションモーダル用
  const [showTemsOfUseUpdateModal, setShowTemsOfUseUpdateModal] =
    useState(false);
  const { user, authStatus, signOut } = useAuthenticator((context) => [
    context.user,
    context.authStatus,
  ]);
  const { windowWidth } = useWindowSize();
  const { isLoading } = useAuthStatus(); // ログイン状態取得のhookを実行

  const components = {
    Header() {
      const { tokens } = useTheme();
      return (
        <View
          textAlign="center"
          padding={tokens.space.large}
          backgroundColor="#ffffff"
        >
          <Image
            alt="MAPPLE"
            src="https://labs.mapple.com/mapple-logo.png"
            className="accountGamen"
          />
        </View>
      );
    },
    Footer() {
      const { tokens } = useTheme();
      return (
        <View
          textAlign="center"
          padding={tokens.space.large}
          backgroundColor="#ffffff"
        >
          <Text color={tokens.colors.neutral[80]}>&copy; MAPPLE,Inc.</Text>
        </View>
      );
    },
    SignIn: {
      Footer() {
        const { toResetPassword } = useAuthenticator();

        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toResetPassword}
              size="small"
              variation="link"
            >
              パスワードを忘れたとき
            </Button>
            <br />
            <Button
              fontWeight="normal"
              onClick={() => {
                setShowAuthenticator(false);
              }}
              size="small"
              variation="link"
            >
              ログインしないで使う
            </Button>
          </View>
        );
      },
    },
    SignUp: {
      //アカウント登録画面に利用規約チェックボックスを追加
      FormFields() {
        const { validationErrors } = useAuthenticator();
        return (
          <>
            <h3>【お客様の情報】</h3>
            <TextField
              label="名前"
              id="name"
              placeholder="お名前を入力"
              name="name"
              type="text"
            ></TextField>
            <TextField
              label="会社名・所属"
              id="company"
              placeholder="会社名や所属組織を入力"
              name="custom:company"
              type="text"
            ></TextField>
            <TextField
              label="部署"
              id="department"
              placeholder="部署名を入力"
              name="custom:department"
              type="text"
            ></TextField>
            <TextField
              label="役職"
              id="director"
              placeholder="役職を入力"
              name="custom:director"
              type="text"
            ></TextField>
            <TextField
              label="所在地・住所"
              id="address"
              placeholder="所在地・住所を入力"
              name="address"
              type="text"
            ></TextField>
            <TextField
              label="電話番号"
              id="tel"
              placeholder="電話番号を入力"
              name="custom:tel"
              type="text"
            ></TextField>
            <RadioGroupField
              label="利用用途"
              name="custom:purposeofuse"
              defaultValue="business"
            >
              <Radio value="business">ビジネスでのご利用</Radio>
              <Radio value="private">プライベートでのご利用</Radio>
            </RadioGroupField>
            <Divider orientation="horizontal" />
            <h3>【ログイン用の情報】</h3>
            <Authenticator.SignUp.FormFields />
            <RiyoukiyakuCheckbox validationErrors={validationErrors} />
          </>
        );
      },
      Footer() {
        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={() => {
                setShowAuthenticator(false);
              }}
              size="small"
              variation="link"
            >
              ログインしないで使う
            </Button>
          </View>
        );
      },
    },
    ConfirmResetPassword: {
      //パスワードリセットの確認画面に「ログインに戻る」を追加
      Footer() {
        const { toSignIn } = useAuthenticator();

        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toSignIn}
              size="small"
              variation="link"
            >
              ログインに戻る
            </Button>
          </View>
        );
      },
    },
  };

  // 外部からログイン画面を表示させるためのイベントリスナー
  useEffect(() => {
    const handleShowAuthenticator = () => {
      setShowAuthenticator(true);
    };
    window.addEventListener("showAuthenticator", handleShowAuthenticator);
    return () => {
      window.removeEventListener("showAuthenticator", handleShowAuthenticator);
    };
  }, []);

  // 利用規約更新ダイアログ表示
  useEffect(() => {
    if (
      authStatus === "authenticated" &&
      user &&
      !isLatestTermsConsented(user)
    ) {
      setShowTemsOfUseUpdateModal(true);
    }
  }, [authStatus, user]);

  return (
    <>
      {authStatus !== "authenticated" ? (
        <BsButton
          variant="primary"
          size={windowWidth < 768 ? "sm" : ""}
          disabled={isLoading}
          onClick={() => {
            setShowAuthenticator(true);
          }}
        >
          {isLoading ? (
            <Spinner as="span" animation="border" size="sm" role="status" />
          ) : (
            "ログイン"
          )}
        </BsButton>
      ) : (
        <Dropdown
          id="signoutbutton"
          title={user?.attributes?.email}
          title2={user?.attributes?.sub}
          align="start"
        >
          <Dropdown.Toggle
            variant="primary"
            size={windowWidth < 768 ? "sm" : ""}
          >
            アカウント
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setShowAccountInfo(true)}>
              アカウント情報
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setShowSubscription(true)}>
              サブスクリプション
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                window.dispatchEvent(new CustomEvent("showOrderHistoryModal"));
              }}
            >
              登記情報購入履歴
            </Dropdown.Item>
            <AccountInfoModal
              show={showAccountInfo}
              onHide={() => setShowAccountInfo(false)}
            />
            <SubscriptionModal
                  show={showSubscription}
                  onHide={() => setShowSubscription(false)}
            />
            <Dropdown.Divider />
            <Dropdown.Item
              onClick={() => {
                signOut();
                setShowAuthenticator(true);
              }}
            >
              ログアウト
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
      {showAuthenticator && (
        <Authenticator
          loginMechanisms={["email"]}
          components={components}
          services={services}
          variation="modal"
        ></Authenticator>
      )}

      {/* 利用規約更新ダイアログ */}
      <TermsOfUseUpdateModal
        show={showTemsOfUseUpdateModal}
        handleClose={() => {
          setShowAuthenticator(false);
          setShowTemsOfUseUpdateModal(false);
        }}
      />
    </>
  );
};

export default LoginButton;
